import React from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaUserCircle, FaBars } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";

const VendorHeader = ({ pageTitle, breadcrumbs, onMenuClick }) => {
  const navigate = useNavigate();
  const { logoutUser, user } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate("/");
  };

  return (
    <div className="bg-white border-bottom px-3 px-md-4 py-3 d-flex justify-content-between align-items-center dashboard-topbar">

      {/* LEFT */}
      <div className="d-flex align-items-center gap-2 gap-md-3 dashboard-topbar-left">

        {/* MOBILE MENU ICON */}
        <button
          className="vendor-menu-btn d-lg-none"
          onClick={onMenuClick}
        >
          <FaBars />
        </button>

        <div className="min-w-0">
          <h5 className="mb-1 fw-bold text-truncate">{pageTitle}</h5>
          <nav className="dashboard-breadcrumbs" style={{ fontSize: "14px" }}>
            {breadcrumbs.map((item, index) => (
              <span key={index}>
                {index !== 0 && " / "}
                <span
                  style={{ cursor: "pointer", color: "#0d6efd" }}
                  onClick={() => navigate(item.url)}
                >
                  {item.label}
                </span>
              </span>
            ))}
          </nav>
        </div>
      </div>

      {/* RIGHT */}
      <div className="d-flex align-items-center gap-2 gap-md-3 dashboard-topbar-right">
        <div className="text-end d-none d-sm-block">
          <div className="fw-semibold">{user?.full_name || user?.name || user?.username || "User"}</div>
          <div style={{ fontSize: "13px", color: "#6c757d" }}>
            {user?.email || "Vendor"}
          </div>
        </div>

        <FaUserCircle size={32} color="#6c757d" />

        <button className="btn btn-danger btn-sm" onClick={handleLogout}>
          <FaSignOutAlt />
        </button>
      </div>
    </div>
  );
};

export default VendorHeader;
